import ListItem from "@/components/ListItem/ListItem";
import { toFormat } from "@/lib/dateHelpers";

export type CurrentCommitteeMemberRow = {
  assignmentId: string;
  personId: string;
  pgaId: string;
  displayName: string;
  profilePhoto: string | null;
  position: string;
  titleId: string;
  startDate: string;
  endDate: string | null;
};

type CurrentCommitteeMembersListProps = {
  members: CurrentCommitteeMemberRow[];
  addDisabled?: boolean;
  onAdd(member: CurrentCommitteeMemberRow): void;
};

export default function CurrentCommitteeMembersList({
  members,
  addDisabled = false,
  onAdd
}: CurrentCommitteeMembersListProps) {
  return (
    <div className="space-y-1" data-testid="current-committee-members-list">
      {members.map((member) => {
        const termDates = `${toFormat(member.startDate)} – ${member.endDate ? toFormat(member.endDate) : "--"}`;

        return (
          <div key={member.assignmentId} data-testid={`current-member-${member.pgaId}`}>
            <ListItem
              compact
              useAvatar
              picture={member.profilePhoto ?? undefined}
              iconName="person"
              headline={member.displayName}
              supportingText={`PGA ${member.pgaId} · ${member.position}\n${termDates}`}
              useCheckbox
              checkboxChecked={false}
              onCheckboxChange={(checked) => {
                if (checked && !addDisabled) onAdd(member);
              }}
              checkboxName={`current-${member.assignmentId}`}
            />
          </div>
        );
      })}
    </div>
  );
}
